import React, {useEffect, useState} from 'react';
import { ComboBox } from '@fluentui/react';
import RemoveValueFromCommaSeparatedString from '../../../Utils/General/RemoveValueFromCommaSeparatedString';

const ArcCombo = (props) => {

    const [focusSet, setFocusSet] = useState(false);
    const [multiSelectValue, setMultiSelectValue] = useState(null);

    let component = React.createRef();

    useEffect(() => {
        if (props.first) {
            if (component.current !== null && component.current !== undefined) {
                if ( ! focusSet) {
                    component.current.focus();
                    setFocusSet();
                }
            }
        }
    }, []);

    let optionsWithCustomStyling = [];

    if (props.config.Options !== undefined) {
        optionsWithCustomStyling = props.config.Options.map((option) => ({
            key: option.key,
            text: option.text,
            ParentKey: option.ParentKey,
            styles: {
              optionText: {
                fontFamily: 'Calibri, Calibri_MSFontService, sans-serif',
                overflow: 'visible',
                whiteSpace: 'normal',
                divider: true
              },
            },
        }));
    }

    
    const singleChangeHandler = (event, value) => {
        if (value === undefined) {
            props.changeHandler(props.config.Id, undefined);
        } else {
            if (value.selected === undefined) {
                props.changeHandler(props.config.Id, value.key, { parentKey: value.ParentKey} );
            } else {
                let newValue= [...props.config.value];
                if (value.selected) {
                    newValue = [...newValue,value.key];
                } else {
                    newValue = [...props.config.value];
                    newValue = newValue.filter(key => key !== value.key);
                }
                props.changeHandler(props.config.Id, newValue, { parentKey: value.ParentKey})
            }
        }
    }

    const multiChangeHandler = (_, value) => {
        if (!value) return;
        let newValue = multiSelectValue === null || multiSelectValue === undefined ? "" : multiSelectValue;
        if (value.selected) {
            newValue += newValue === "" ? value.key : "," + value.key;
        } else {
            newValue = RemoveValueFromCommaSeparatedString(newValue, value.key, ",");
        }
        setMultiSelectValue(newValue);
        props.changeHandler(props.config.Id, newValue, { parentKey: value.ParentKey} );
    }

    //const value = props.config.value !== undefined ? props.config.value.toString() : props.config.value;

    let newValue = null;
    if (props.config.value) {
        newValue = props.config.value.toString();
        newValue = props.config.MultiSelect ? newValue.split(",") : newValue;
    }

    const tabIndex = props.config.noTab === undefined || !props.config.noTab ? undefined : -1;

    return (props.config.Options && props.config.Options.length > 0)  ?
         (
            <ComboBox
                onKeyDown={props.onKeyDown}
                id={props.config.Id}
                required={props.config.Required}
                //openOnKeyboardFocus={true}
                placeholder={props.config.Placeholder}
                label={props.config.Label}
                allowFreeform
                autoComplete="on"
                componentRef = {component}
                useComboBoxAsMenuWidth
                multiSelect = {props.config.MultiSelect}
                selectedKey = {newValue}
                options={optionsWithCustomStyling}
                onChange={props.config.MultiSelect ? multiChangeHandler : singleChangeHandler}
                tabIndex={tabIndex}
            />
        )
        : null;   
}

export default ArcCombo;